import { render, staticRenderFns } from "./courseAfrrimShopping.vue?vue&type=template&id=975accd6"
import script from "./courseAfrrimShopping.vue?vue&type=script&lang=js"
export * from "./courseAfrrimShopping.vue?vue&type=script&lang=js"
import style0 from "./courseAfrrimShopping.vue?vue&type=style&index=0&id=975accd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports